// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Switch_wrap__u9MjO","active":"Switch_active__ruxis","circle":"Switch_circle__CDQG7","input":"Switch_input__jmcrU"};